function debounce(func, wait, immediate) {
  var timeout;
  return {
    func: function() {
      var context = this,
          args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    },
    cancel: function() {
      clearTimeout(timeout);
    }
  };
}

window.oaPicture = (function() {
  // [0]: hostname + pathname
  // [1]: size (_100x or _x100 or _100x100)
  // [2]: scale (undefined or @2x or @3x)
  // [3]: format (.png or .jpg)
  // [4]: version (?v=1234)
  // [5]: dpr (1x or 2x or 3x)
  var replaceImgRegex = /(_\d+x|_x\d+|_\d+x\d+)?(@\dx)?(\.jpg|\.png|\.gif|\.mp4)(\?v=\d+)( \dx)?/;

  function replaceImgUrlAdvanced(oldSrc, newSrc, master) {
    var oldParts = oldSrc.split(replaceImgRegex);
    var newParts = newSrc.split(replaceImgRegex);
    oldParts[0] = newParts[0];
    if (master === true) {
      oldParts[1] = '';
      oldParts[2] = '';
    }
    oldParts[3] = newParts[3];
    oldParts[4] = newParts[4];
    return oldParts.join('');
  }

  function replaceImgSrcsetUrlsAdvanced(oldSrcset, newSrc) {
    return oldSrcset.split(/, ?/).map(function(part) {
      return replaceImgUrlAdvanced(part, newSrc);
    }).join(', ');
  }

  function replaceImgSrc(element, src) {
    var img = element.getElementsByTagName('img')[0];
    if ((img.dataset && img.dataset.wasProcessed) || (typeof img.src !== 'undefined' && img.src)) {
      img.src = replaceImgUrlAdvanced(img.src, src);
    } else {
      img.dataset.src = replaceImgUrlAdvanced(img.dataset.src, src);
    }
  }

  function replaceSourcesSrc(element, src) {
    var sources = Array.prototype.slice.call(element.getElementsByTagName('source'));
    sources.forEach(function(source) {
      if (typeof source.srcset !== 'undefined' && source.srcset) {
        source.srcset = replaceImgSrcsetUrlsAdvanced(source.srcset, src)
      } else {
        source.dataset.srcset = replaceImgSrcsetUrlsAdvanced(source.dataset.srcset, src);
      }
    });
  }

  function replaceDataZoomSrc(element, src) {
    var img = element.getElementsByTagName('img')[0];
    if (img.dataset && typeof img.dataset.zoomSrc !== 'undefined' && img.dataset.zoomSrc) {
      img.dataset.zoomSrc = replaceImgUrlAdvanced(img.dataset.zoomSrc, src);
    }
  }

  function replaceDataMagnifySrc(element, src) {
    var img = element.getElementsByTagName('img')[0];
    if (img.dataset && typeof img.dataset.magnifySrc !== 'undefined' && img.dataset.magnifySrc) {
      img.dataset.magnifySrc = replaceImgUrlAdvanced(img.dataset.magnifySrc, src);
    }
  }

  function replacePictureSrcAdvanced(element, src) {
    var elements = [];
    if (typeof jQuery === 'function' && element instanceof jQuery) {
      elements = Array.prototype.slice.call(element.toArray());
    } else if (!Array.isArray(element)) {
      elements = [element];
    }

    elements.forEach(function(element) {
      if (element.tagName === 'IMG') {
        element = element.closest('picture');
      }
      if (element.tagName !== 'PICTURE') {
        element = element.querySelector('picture');
      }
      if (element.tagName === 'PICTURE') {
        replaceImgSrc(element, src);
        replaceSourcesSrc(element, src);
        replaceDataZoomSrc(element, src);
        replaceDataMagnifySrc(element, src);
      }
    });
  }

  return {
    replaceSrc: replacePictureSrcAdvanced
  };

})();



document.addEventListener('DOMContentLoaded', function() {
  //Additional FB& IG Tracking
  function addToCartAd(){
    if (Cookies.get('adfb') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="FB"></option></select>');
    }else if(Cookies.get('adig') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="IG"></option></select>');
    }
  }addToCartAd();

  window.oaProductZoom = (function() {
    var id = 'product_zoom',
        idSmile = 'smile-ui-container',
        idButtonClose = 'product_zoom_close',
        idMobile = 'product_zoom_mobile',
        idMobileIconWrapper = 'product_zoom_icon_wrapper',
        idMobilePinch = 'product_zoom_mobile_pinch',
        idDesktopSwiper = 'product_zoom_desktop_swiper',
        classShow = 'oa-product-zoom--show',
        classMobileImg = 'oa-product-zoom-mobile__img',
        classMobileImgMaster = 'oa-product-zoom-mobile__img--master',
        classMasterShow = 'oa-product-zoom-mobile__img--master-show',
        classDesktopZoomContainer = 'oa-product-zoom-desktop__swiper-zoom-container',
        elZoom,
        elButton,
        elMobile,
        pinchZoom,
        elIcon,
        elPinch,
        elPictureWrapper,
        elPictureCanvas,
        elPictureImg,
        elPictureImgMaster,
        elVideo,
        elDesktopSwiper,
        rectDesktopWrapper;

    function measureScrollbarWidth() {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      var scrollbarWith = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWith;
    }

    function setScrollbarAdjustments() {
      var rect = document.body.getBoundingClientRect();
      var isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      var scrollbarWidth = measureScrollbarWidth();

      if (isBodyOverflowing) {
        // Adjust body padding
        var actualPadding = document.body.style.paddingRight;
        var actualOverflow = document.body.style.overflow;
        var calculatedPadding = window.getComputedStyle(document.body).paddingRight;

        document.body.dataset.paddingRight = actualPadding;
        document.body.dataset.overflow = actualOverflow;
        document.body.style.paddingRight = (parseFloat(calculatedPadding) + scrollbarWidth) + 'px';
        document.body.style.overflow = 'hidden';
      }
    }

    function resetScrollbarAdjustments() {
      var padding = document.body.dataset.paddingRight;
      var overflow = document.body.dataset.overflow;
      if (typeof padding === 'undefined') {
        document.body.style.paddingRight = '';
      } else {
        document.body.dataset.paddingRight = '';
        document.body.dataset.overflow = '';
        document.body.style.paddingRight = padding;
        document.body.style.overflow = overflow;
      }
    }

    function isDesktop() {
      return window.getComputedStyle(elMobile).display === 'none';
    }

    function resetZoom() {
      if (!elPinch.style.height) {
        pinchZoom.setContainerY(elZoom.clientHeight);
      }

      var scaleX = pinchZoom.getContainerX() / pinchZoom.el.clientWidth;
      var scaleY = pinchZoom.getContainerY() / pinchZoom.el.clientHeight;
      var scale = Math.max(scaleY, pinchZoom.el.clientHeight / pinchZoom.getContainerY());
      var scaleOffset = Math.max(scaleY, scaleX);
      pinchZoom.initialOffset.x = (pinchZoom.getContainerX() - pinchZoom.el.clientWidth) / 2;
      pinchZoom.initialOffset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight) / 2;
      pinchZoom.offset.x = (pinchZoom.getContainerX() * scaleOffset - pinchZoom.el.clientWidth) / 2;
      pinchZoom.offset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight * scaleOffset) / 2;
      pinchZoom.zoomFactor = scale;
      pinchZoom.lastScale = scale;
      pinchZoom.options.minZoom = scale;
      pinchZoom.options.zoomOutFactor = scale;
      pinchZoom.update();
    }

    function resetSwiper() {
      //
    }

    function reset() {
      if (isDesktop()) {
        resetSwiper();
      } else {
        resetZoom();
      }
    }

    function hideSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = 'none';
      }
    }

    function showSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = '';
      }
    }

    function updateHTMLPosition() {
      hideSmile();
      setTimeout(function() {
        if (!isDesktop()) {
          document.body.appendChild(elZoom);
        }
        hideSmile();
      }, 500);
    }

    function getRectDesktopWrapper() {
      rectDesktopWrapper = document.querySelector('#' + idDesktopSwiper + ' .swiper-wrapper').getBoundingClientRect(window);
    }

    var onResize = debounce(getRectDesktopWrapper, 200);

    function hide() {
      elZoom.classList.remove(classShow);
      showSmile();
      if (isDesktop()) {
        resetScrollbarAdjustments();
        resetSwiper();
        window.removeEventListener('resize', onResize.func, false);
      } else {
        if (elPictureImg) {
          elPictureWrapper.removeChild(elPictureImg);
          elPictureImg = null;
        }
        if (elVideo) {
          elPictureWrapper.removeChild(elVideo);
          elVideo = null;
        }
        elPictureImgMaster.classList.remove(classMasterShow);
        elPictureImgMaster.src = '';
        resetZoom();
      }
    }

    function initMobile() {
      if (elZoom && pinchZoom) {
        return;
      }

      function setupPinchZoom() {
        if (typeof pinchZoom !== 'undefined') {
          return;
        }
        pinchZoom = new PinchZoom(elPinch, {
          tapZoomFactor: 3,
          zoomOutFactor: 3,
          animationDuration: 500,
          minZoom: 1,
          maxZoom: 3,
          draggableUnzoomed: true,
          setOffsetsOnce: true,
          lockDragAxis: false
        });
      }

      elPictureWrapper = document.createElement('div');
      elPictureWrapper.className = 'oa-picture-wrapper oa-video-wrapper';
      elPictureCanvas = document.createElement('canvas');
      elPictureCanvas.className = 'oa-picture__canvas';
      elPictureImgMaster = document.createElement('img');
      elPictureImgMaster.className = 'oa-picture__img ' + classMobileImg + ' ' + classMobileImgMaster;
      elPictureImgMaster.alt = '';

      elPictureWrapper.appendChild(elPictureCanvas);
      elPinch.appendChild(elPictureWrapper);

      setupPinchZoom();

      // NOTE: Add <img> after initializing PinchZoom to prevent event listeners being added to them.
      elPictureWrapper.appendChild(elPictureImgMaster);

      resetZoom();

      elPictureImgMaster.addEventListener('load', function() {
        elPictureImgMaster.classList.add(classMasterShow);
      });
    }

    function initDesktop(clickEvent) {
      if (elZoom && elDesktopSwiper) {
        return;
      }

      var lastOffsetX;
      var lastOffsetY;

      function setInitialOffsets(clickEvent) {
        if (rectDesktopWrapper.left <= clickEvent.x && clickEvent.x <= rectDesktopWrapper.right) {
          lastOffsetX = clickEvent.x - rectDesktopWrapper.left;
          if (rectDesktopWrapper.top <= clickEvent.y && clickEvent.y <= rectDesktopWrapper.bottom) {
            lastOffsetY = clickEvent.y - rectDesktopWrapper.top;
          }
        }
      }

      function setupSwiper() {
        if (typeof elDesktopSwiper !== 'undefined') {
          return;
        }

        function getCoordinates(swiper, event) {
          if (event) {
            lastOffsetX = event.x - rectDesktopWrapper.left;
            lastOffsetY = event.y - rectDesktopWrapper.top;
          }
          var x = Math.min(Math.max((lastOffsetX / swiper.$(swiper.wrapperEl).outerWidth()) * 100, 0), 100);
          var y = Math.min(Math.max((lastOffsetY / swiper.$(swiper.wrapperEl).outerHeight()) * 100, 0), 100);
          return [x, y];
        }

        function onMouseLeave(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(225).transform('translate3d(0,0,0) scale(1)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
          if (event) {
            lastOffsetX = undefined;
            lastOffsetY = undefined;
          }
        }
        function onMouseMove(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          if (typeof lastOffsetX === 'undefined' || typeof lastOffsetY === 'undefined') { return; }
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(0).css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }
        function onMouseEnter(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(0).transform('translate3d(0,0,0) scale(2)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }

        elDesktopSwiper = new Swiper('#' + idDesktopSwiper, {
          on: {
            init: function() {
              var swiper = this;
              swiper.$wrapperEl.each(function(elIndex, elWrapper) {
                elWrapper = swiper.$(elWrapper);
                elWrapper.on('mouseenter', onMouseEnter.bind(swiper), false);
                elWrapper.on('mousemove', onMouseMove.bind(swiper), false);
                elWrapper.on('mouseleave', onMouseLeave.bind(swiper), false);
              });
              swiper.$zoomEl = swiper.$wrapperEl.find('.' + classDesktopZoomContainer);
            },
          },
          direction: 'vertical',
          slidesPerView: 1,
          spaceBetween: 10,
          initialSlide: 0,
          roundLengths: true, //prevent blurry text
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: true
          },
          speed: 500,
          loop: false,
          autoplay: false,
          lazyLoad: {
            enabled: true,
            loadPrevNext: true
          },
          thumbs: {
            swiper: {
              el: '#product_zoom_desktop_swiper_thumbs',
              direction: 'vertical',
              slidesPerView: 6,
              spaceBetween: 5,
              roundLengths: true, //prevent blurry text
              mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
                invert: true
              },
              speed: 500,
              loop: false,
              autoplay: false,
              lazyLoad: true
            }
          }
        });
      }

      getRectDesktopWrapper();
      setupSwiper();

      if (clickEvent) {
        setInitialOffsets(clickEvent);
      }

      resetSwiper();
    }

    function showMobile(srcEl) {
      if (!srcEl || !(Boolean(srcEl.dataset.zoomSrc) || srcEl.tagName === 'VIDEO')) {
        return;
      }

      initMobile();

      if (srcEl.tagName === 'VIDEO') {
        elVideo = srcEl.cloneNode(true);

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elVideo, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.alt = '';
        elPictureImgMaster.setAttribute('aria-hidden', 'true');
        elPictureImgMaster.src = '';
      } else {
        elPictureImg = (srcEl.tagName === 'PICTURE' ? srcEl : srcEl.closest('picture')).cloneNode(true);
        elPictureImg.querySelector('img').className = 'oa-picture__img ' + classMobileImg;
        var srcMaster = srcEl.dataset.zoomSrc;
        if (!elPictureImg || !srcMaster) {
          return;
        }

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elPictureImg, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.alt = srcEl.getAttribute('alt') || '';
        if (elPictureImgMaster.alt) {
          elPictureImgMaster.removeAttribute('aria-hidden');
        } else {
          elPictureImgMaster.setAttribute('aria-hidden', 'true');
        }
        elPictureImgMaster.src = srcMaster;
      }
    }

    function showDesktop(srcEl, clickEvent) {
      if (!srcEl || typeof srcEl.dataset.index === 'undefined') {
        return;
      }

      setScrollbarAdjustments();

      elZoom.classList.add(classShow);

      initDesktop(clickEvent);

      resetSwiper();

      var index = parseInt(srcEl.dataset.index) || 0;

      elDesktopSwiper.slideTo(index, 0);
    }

    function show(srcEl, clickEvent) {
      if (!srcEl) {
        return;
      }

      if (!elZoom) {
        elZoom = document.getElementById(id);
        elButton = document.getElementById(idButtonClose);
        elMobile = document.getElementById(idMobile);
        elIcon = document.getElementById(idMobileIconWrapper);
        elPinch = document.getElementById(idMobilePinch);
        elButton.addEventListener('click', hide, { passive: true });

        document.body.appendChild(elZoom);

        updateHTMLPosition();
        document.addEventListener('OAContentLoaded', updateHTMLPosition, false);
        document.addEventListener('sweettooth-ready', updateHTMLPosition, false);

        if (isDesktop()) {
          window.addEventListener('resize', onResize.func, false);
        }
      }

      if (isDesktop()) {
        showDesktop(srcEl, clickEvent);
      } else {
        showMobile(srcEl);
      }

      hideSmile();
    }

    return {
      reset: reset,
      show: show
    };
  })();


  Array.prototype.slice.call(document.querySelectorAll('.oa-fashion__product-image-container .oa-picture__img, .oa-fashion__product-image-container .oa-video-wrapper video')).forEach(function(image) {
    image.addEventListener('click', function (event) {
      window.oaProductZoom.show(event.target, event);
    }, { passive: true });
  });

  var product_image_slider = document.getElementById('product_image_slider_mobile');
  if (!product_image_slider || product_image_slider.className.indexOf('swiper-container-initialized') !== -1) {
    return;
  }

  var product_image_slider_thumbs = document.getElementById('product_image_slider_mobile_thumbs');
  var thumbs = {};
  if (product_image_slider_thumbs) {
    thumbs.swiper = {
      el: product_image_slider_thumbs,
      navigation: {
        nextEl: '#' + product_image_slider_thumbs.id + ' + .oa-slider__nav .oa-slider__nav-next',
        prevEl: '#' + product_image_slider_thumbs.id + ' + .oa-slider__nav .oa-slider__nav-prev',
        disabledClass: 'oa-slider__nav--disabled',
        hiddenClass: 'oa-slider__nav--disabled'
      },
      slidesPerView: 4,
      spaceBetween: 5,
      roundLengths: true, //prevent blurry text
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      lazyLoad: true
    };
  }

  var swiper = new Swiper(product_image_slider, {
    on: {
      click: function(event) {
        window.oaProductZoom.show(event.target);
      }
    },
    navigation: {
      nextEl: '#' + product_image_slider.id + ' .oa-product-image-slider__nav-next',
      prevEl: '#' + product_image_slider.id + ' .oa-product-image-slider__nav-prev',
      disabledClass: 'oa-product-image-slider__nav--disabled',
      hiddenClass: 'oa-product-image-slider__nav--disabled'
    },
    scrollbar: {
      el: '.oa-product-image-slider__scrollbar',
      dragClass: 'oa-product-image-slider__scrollbar-drag',
      draggable: false,
    },
    slidesPerView: 1,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    lazyLoad: {
      enabled: true,
      loadPrevNext: true
    },
    thumbs: thumbs
  });

  function updateVariantMediaElement(element, newData) {
    if (!newData) { return; }
    if (element.tagName === 'VIDEO') {
      var parser = new DOMParser();
      var newElement = parser.parseFromString(newData, 'text/html').body.firstChild;
      element.parentNode.replaceChild(newElement, element);
      newElement.addEventListener('loadeddata', function (event) { newElement.play(); }, false);
      newElement.load();
    } else {
      window.oaPicture.replaceSrc(element, newData);
    }
  }
  document.addEventListener('oa:variantchange', function (event) {
    if (!window.oaProductMediaData || !event.detail.sizeName) {
      return;
    }
    if (event.detail.sizeName == 'XL' && window.location.href.includes('classic-seamless-sports-bra')) {
      return;
    }

    if($('#in-den-warenkorb span:first').text().trim() !== $('#in-den-warenkorb').attr('data-text-instock')){
      $('#in-den-warenkorb span').text($('#in-den-warenkorb').attr('data-text-instock'));
    }

    var data = window.oaProductMediaData[event.detail.sizeName.toLowerCase()];
    Array.prototype.slice.call(document.querySelector('.oa-fashion__product-image-container').querySelectorAll('picture,video')).forEach(function (element, index) {
      updateVariantMediaElement(element, data[index]);
    });

    Array.prototype.slice.call(product_image_slider.querySelectorAll('.swiper-slide picture,.swiper-slide video')).forEach(function (element, index) {
      updateVariantMediaElement(element, data[index]);
    });
    if (window.lazyLoadInstance) { window.lazyLoadInstance.update(); }

  }, false);

  window.oaProductSlider = {
    slideTo: function (index) {
      swiper.slideToLoop(index);
    }
  };

}, { passive: true });



document.addEventListener('DOMContentLoaded', function() {

  var color_switch_slider = document.getElementById('fashion-color-switch');
  var color_switch_title = document.getElementById('fashion-color-switch-item-title');
  if (!color_switch_slider || color_switch_slider.className.indexOf('swiper-container-initialized') !== -1 || document.getElementById('fashion-color-switch')) {
    return;
  }

  var swiper = new Swiper(color_switch_slider, {
    on: {
      init: function() {
        var classNoActive = 'oa-fashion-color-switch--noactive';
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.item a'));
        var current_title = color_items[0].getAttribute('title');

        function resetColorSwitchTitle() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }

        var resetColorSwitchTitleDebounced = debounce(resetColorSwitchTitle, 225);

        color_items[0].addEventListener('mouseenter', function() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }, { passive: true });
        color_items.slice(1).forEach(function(el) {
          el.addEventListener('mouseenter', function() {
            resetColorSwitchTitleDebounced.cancel();
            color_switch_slider.classList.add(classNoActive);
            color_switch_title.innerText = el.getAttribute('title');
          }, { passive: true });
          el.addEventListener('mouseleave', resetColorSwitchTitleDebounced.func);
        });
        color_switch_slider.addEventListener('mouseleave', resetColorSwitchTitle, { passive: true });
      }
    },
    navigation: {
      nextEl: '#' + color_switch_slider.id + ' .oa-fashion-color-switch__nav-next',
      prevEl: '#' + color_switch_slider.id + ' .oa-fashion-color-switch__nav-prev',
      disabledClass: 'oa-fashion-color-switch__nav--disabled',
      hiddenClass: 'oa-fashion-color-switch__nav--disabled'
    },
    slidesPerView: 'auto',
    spaceBetween: 5,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    speed: 500,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true
  });

}, { passive: true });



document.addEventListener('DOMContentLoaded', function () {

  window.changeVariantImages = function changeVariantImages(variant) {
    var flavorId = variant.getAttribute('data-flavor');
    var imgSrc = variant.getAttribute('data-img-src');
    Array.prototype.slice.call(document.querySelectorAll('.giftcard-info-flex [data-flavors]')).forEach(function (element) {
      if (flavorId && imgSrc && element && (element.getAttribute('data-flavors') || '').split(/,/).indexOf(flavorId) !== -1) {
        window.oaPicture.replaceSrc(element, imgSrc);
      }
    });
  }

  function setupFlavorButtons() {
    Array.prototype.slice.call(document.querySelectorAll('.product-flavors-container')).forEach(function (element) {
      var title = element.querySelector('.product-flavors-title__variant');
      var list = element.querySelector('.product-flavors');
      if (!title || !list) {
        return;
      }

      function handleFlavorChange(flavors, flavor, event) {
        if (flavor.classList.contains('disabled') || flavor.hasAttribute('disabled')) {
          return;
        }
        flavors.forEach(function (flavor) {
          flavor.classList.remove('active');
        });
        flavor.classList.add('active');
        list.classList.remove('red');
        title.innerText = flavor.innerText;
        window.changeVariantImages(flavor);
      }

      var flavors = Array.prototype.slice.call(list.querySelectorAll('li'));
      flavors.forEach(function (flavor) {
        flavor.addEventListener('click', handleFlavorChange.bind(null, flavors, flavor));
        flavor.addEventListener('mouseenter', function () {
          title.innerText = flavor.innerText;
        });
        flavor.addEventListener('mouseleave', function () {
          flavors.forEach(function (flavor) {
            if (!flavor.classList.contains('active')) {
              return;
            }
            title.innerText = flavor.innerText;
          });
        });
      });
    });
  }

  function setupQuantityInput() {
    Array.prototype.slice.call(document.querySelectorAll('.oa-quantity-input')).forEach(function (element) {
      var input = element.querySelector('input');
      var decButton = element.querySelector('button[data-quantity-dec]');
      var incButton = element.querySelector('button[data-quantity-inc]');
      if (!input || !decButton || !incButton) {
        return;
      }
      var minValue = input.hasAttribute('min') ? Number(input.getAttribute('min')) : 1;
      var maxValue = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Number.MAX_SAFE_INTEGER;
      decButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.max(minValue, Number(input.value) - 1);
      });
      incButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.min(maxValue, Number(input.value) + 1);
      });
    });
  }

  setupFlavorButtons();
  setupQuantityInput();

}, { passive: true });

jQuery(document).ready( function($) {
  function setupReadMore() {
    var showChar = 480;
    var ellipsestext = "";
    var moretext = "... Show more";
    var lesstext = "Show less";
    var counter = 1;
    var t = 200,linear;
    switch (document.documentElement.lang) {
      case "de":
        moretext = "... mehr";
        lesstext = "weniger";
        break;
      case "fr":
        moretext = "... montre plus";
        lesstext = "montre moins";
        break;
    }
    $('.more p').first().addClass('first-p');
    $('.more').each(function(index) {
      var content = $(this).html();
      var textLength = $(this).text();
      var moreElement = $(this);
      //console.log(index)


      var c = content.substr(0, showChar);

      var h = content.substr(showChar, content.length);


      var l = c.length + h.indexOf('.')+1;

      c = content.substr(0,l);

      h = content.substr(l, content.length);




      // console.log(c,h);


      //console.log(content.length,l,h.length)


      //console.log('c:'+ c);
      //console.log('h:'+ h);


      if(content.length > l && h.length > 50) {

        $(this).addClass('add-more-setup');

        //console.log('c:'+ c);
        //console.log('h:'+ h);

        //var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        $(this).html(html);
      }




      if($('.morelink'+index).is(':visible')){
      }else {
        $('.first-'+index+' p:nth-child(2)').show();
        $('.morecontent'+index).hide();
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(3)').show();
          $('.morecontent'+index).hide();

        }
      }
      $(".morelink"+index).click(function(){
        $('.more-'+index+' .last').show(t);
        $('.more-'+index+' .first').hide(t);
        $(this).addClass("less");
        $('.morelink'+index).html(lesstext);
        $('.more'+index+' .first-p span').show(t);
        $('.more-'+index+' p').show(t);
        $('.more-'+index+' .first-p span').show(t);
        $('.morecontent'+index).show(t);

      });
      $(".lesslink"+index).click(function(){
        $('.more-'+index+' .first').show(0);
        $('.more-'+index+' .last').hide(0);
        $(this).removeClass("less");
        $('.more-'+index+' p').hide(0);
        $('.morecontent'+index).hide(0);
        $('.more-'+index+'first-p').css('display','bock!important');
        $(".more-"+index+" .first-p:not('.morecontent')").show(0);
        $('.more-'+index+' .first-p span').hide(0);
        $('.morelink'+index).html(moretext);
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(2)').show();
          $('.morecontent'+index).hide();
          if($('.morelink'+index).is(':visible')){
          }else {
            $('.first-'+index+' p:nth-child(3)').show();
            $('.morecontent'+index).hide();
          }
        }
        return false;
      });
    });
  }

  // Remove title class from content box
  $('.tab-content p').removeClass('product__bundle-title');

  //
  //
  // Default variant select
  //
  //
  var variantDefaultValue = $('.oa-product_native-variants span:first');

  $(".oa-fashion-variants").on('change', function() {
    if($(this).val()!=="") {
      $('.oa-product-addtocart-btn').css('cursor','pointer');
      $('.oa-product-addtocart-btn').removeClass('disabled');
      $('.oa-product-addtocart-btn').prop('disabled', false);
      $('.ajaxified-cart-feedback').hide();
      $('.oa-variant-select').css('border','none');
    }
  });

  $(".oa-fashion-variants").on('click', function(e){
    e.preventdefault;

    if ($(".oa-fashion-variants").hasClass('disabled')){
      //console.log('test');
    }
  });

  //
  //
  // Free shipping on Product Page
  //
  //

  var shippingText = $('.oa-header_shipping-text').first().text();
  $('#pp_shipping-text').html(shippingText);

  //
  //
  // QTY INPUT
  // Neues ProductPage Screendesign Aug2017
  //
  var $qtyInputGroup = $('.oa-qty-input');
  var $qtyDecButton = $qtyInputGroup.find('.btn-dec');
  var $qtyIncButton = $qtyInputGroup.find('.btn-inc');
  var $qtyInput = $qtyInputGroup.find('.qty-input');
  var maxqty = 50;
  $qtyIncButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    $qtyInput.val( val + 1);
    if($qtyInput.val() >maxqty){
      $qtyInput.val( maxqty );
    }
  });

  $qtyDecButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    if( val > 1){
      $qtyInput.val( val - 1);
    }
  });

  $qtyInput.on('change', function(e) {
    if( $qtyInput.val() > maxqty){
      $qtyInput.val( maxqty );
    }
  });


  var $variant_select = $('.oa-product-variants');

  $variant_select.selectpicker({
    style: 'oa-variant-select btn-lg',
    dropupAuto: false
  });
  $variant_select.selectpicker('refresh');
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
    $variant_select.selectpicker('mobile');
  }

  $(".oa-product-variants > option").each(function() {
    var status = $(this).data('available');
    if(status == 'false'){
      var index =  $(this).index();
      $('.oa-product-variants .dropdown-menu').find("[data-original-index='" + index + "']").addClass('disabled');
    }
  });

  function setupVariantDropdowns() {
    var variantDropdowns = Array.prototype.slice.call(document.querySelectorAll('#add-to-cart-form select.oa-product-variants'));

    function updateVariantPrice(selectedOption) {
      var priceCompareTarget = $('.oa-single-product_meta-container [data-price-compare-target]');
      var priceOffTarget = $('.oa-single-product_meta-container [data-price-off-target]');
      var priceTarget = $('.oa-single-product_meta-container [data-price-target]');

      var priceCompare = selectedOption.dataset.priceCompare;
      var hasCompare = (priceCompare || '').length > 0;
      if (typeof priceCompare !== 'undefined') {
        priceCompareTarget.html(priceCompare);
      }
      priceCompareTarget.css('display', hasCompare ? '' : 'none');

      var priceOff = selectedOption.dataset.priceOff;
      if (priceOff !== 'undefined') {
        priceOffTarget.html(priceOff);
      }
      priceOffTarget.css('display', hasCompare ? '' : 'none');

      var price = selectedOption.dataset.price;
      if (typeof price !== 'undefined') {
        priceTarget.html(price);
      }
      if (hasCompare) {
        priceTarget.addClass('product-price__price--has-compare');
      } else {
        priceTarget.removeClass('product-price__price--has-compare');
      }

      if (typeof window.updatePPBestPoints !== 'undefined') {
        var priceCents = selectedOption.dataset.priceCents;
        if (typeof priceCents !== 'undefined') {
          window.updatePPBestPoints(priceCents);
        }
      }
    }

    function handleVariantChange(e) {
      var selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) {
        return;
      }
      window.oaProductSlider.slideTo(0);
      window.changeVariantImages(selectedOption);
      //updateVariantPrice(selectedOption);
    }

    variantDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', handleVariantChange, { passive: true });
      dropdown.addEventListener('change', function (event) {
        var $this = $(event.target.options[event.target.selectedIndex]);
        document.dispatchEvent(new CustomEvent('oa:variantchange', { detail: { sku: $this.data('sku'), id: $this.data('flavor') } }));
      }, false);
      handleVariantChange.call(dropdown);
    });
  }

  setupVariantDropdowns();
  setupReadMore();

});


document.addEventListener('DOMContentLoaded', function () {

  function setupFashionView() {
    //Size SELECT
    var $input = $('#variant-id');
    var $addToCartBtn = $('.oa-product-addtocart-btn');
    var $sizeBtns = $('.fashion-info-sticky ul.product-sizes li');
    var $sizeBtnsSelected = $('.fashion-info-sticky ul.product-sizes li.oa-product-sizes--item-size');


    //PP Fashion Long/short switch
    $('.product-sizes .oa-product-sizes--item').not('#cts-modal .product-sizes .oa-product-sizes--item, #product-stl .product-sizes .oa-product-sizes--item').click(function(){
      var $selectedSize = $('.oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').attr('data-size-name');
      var $sizeSelection = $(this).attr('data-selection-size');
      var $fashionVariant= $('.oa-product-sizes--item-size-'+$sizeSelection+'[data-size-name="'+$selectedSize+'"]').not('#cts-modal.oa-product-sizes--item-size-'+$sizeSelection+'[data-size-name="'+$selectedSize+'"], #product-stl.oa-product-sizes--item-size-'+$sizeSelection+'[data-size-name="'+$selectedSize+'"]');
      var $wrapper = $('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper');
      
      $('.product-sizes .oa-product-sizes--item').not('#cts-modal .product-sizes .oa-product-sizes--item, #product-stl .product-sizes .oa-product-sizes--item').removeClass('active');
      //$input.val('');
      $sizeBtnsSelected.removeClass('active');
      $(this).addClass('active');
      $('.oa-single-product_meta-container .product-length-wrapper').not('#cts-modal .product-length-wrapper, #product-stl .product-length-wrapper').removeClass('red');
      


      if ($('.oa-single-product_meta-container .oa-product-sizes--item-size').hasClass('product-sizes-pdp')) {
        $('.product-sizes-pdp').not('#cts-modal .product-sizes-pdp, #product-stl .product-sizes-pdp').addClass('product-sizes-hidden');
        $('.product-sizes-pdp.oa-product-sizes--item-size-'+$sizeSelection).not('#cts-modal .product-sizes-pdp.oa-product-sizes--item-size-'+$sizeSelection, '#product-stl .product-sizes-pdp.oa-product-sizes--item-size-'+$sizeSelection).removeClass('product-sizes-hidden');
      } else {
        $('.oa-single-product_meta-container .oa-product-sizes--item-size').not('#cts-modal .oa-product-sizes--item-size, #product-stl .oa-product-sizes--item-size').hide();
        $('.oa-single-product_meta-container .oa-product-sizes--item-size-'+$sizeSelection).not('#cts-modal .oa-product-sizes--item-size-'+$sizeSelection, '#product-stl .oa-product-sizes--item-size-'+$sizeSelection).show();
      }
      
      $('.oa-single-product_meta-container .product-sizes-title-size').not('#cts-modal .product-sizes-title-size, #product-stl .product-sizes-title-size').show();

      $wrapper.removeClass();
      $wrapper.addClass('product-sizes-wrapper product-sizes').addClass($('.oa-product-logos--item.active').attr('data-selection-logo')).addClass($('.oa-product-sizes--item.active').attr('data-selection-size'));
      if($selectedSize!=undefined && !$fashionVariant.hasClass('disabled')){
        $fashionVariant.addClass('active');
        if($('.oa-product-sizes--item').not('#cts-modal .oa-product-sizes--item, #product-stl .oa-product-sizes--item').hasClass('active')&&$('.oa-product-sizes--item-size').not('#cts-modal .oa-product-sizes--item-size, #product-stl .oa-product-sizes--item-size').hasClass('active')){
          $addToCartBtn.attr("disabled", false);
          $('.oa-single-product_meta-container #oa-fashion .fashion-info-flex #in-den-warenkorb').not('#oa-fashion #cts-modal .fashion-info-flex #in-den-warenkorb, #oa-fashion #product-stl .fashion-info-flex #in-den-warenkorb').removeClass('select');
          $('.oa-single-product_meta-container .product-sizes').not('#cts-modal .product-sizes, #product-stl .product-sizes').removeClass('red');
          $('.oa-single-product_meta-container .choose-size-alert').not('#cts-modal .choose-size-alert, #product-stl .choose-size-alert').hide(100);
          $input.val($('.oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').attr('data-size'));
        }
      } else {
        if($('.oa-single-product_meta-container .oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').length == 0){
         $input.val('');
        }
      }
      if($('.oa-single-product_meta-container .oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').length == 0){
        $input.val('');
      }
    });

    
    //PP Fashion Long/short switch cts-modal
    $('#cts-modal .oa-product-sizes--item').click(function(){
      var $selectedSize = $('#cts-modal .oa-product-sizes--item-size.active').attr('data-size-name');
      var $sizeSelection = $(this).attr('data-selection-size');
      var $fashionVariant= $('#cts-modal .oa-product-sizes--item-size-'+$sizeSelection+'[data-size-name="'+$selectedSize+'"]');
      var $formID = $(this).closest('form').attr('id');
      var $wrapper = $('#cts-modal .product-sizes-wrapper');
      $('#cts-modal .product-sizes .oa-product-sizes--item').not('#cts-modal .product-sizes .oa-product-sizes--item, #product-stl .product-sizes .oa-product-sizes--item').removeClass('active');
      //$input.val('');
      $('#cts-modal .product-sizes .oa-product-sizes--item').removeClass('active');
      $sizeBtnsSelected.removeClass('active');
      $(this).addClass('active');
      $('#cts-modal .product-length-wrapper').not('#product-stl .product-length-wrapper').removeClass('red');
      $('#cts-modal #' + $formID + ' .oa-product-sizes--item-size').hide();
      $('#cts-modal #' + $formID + ' .oa-product-sizes--item-size-'+$sizeSelection).show();
      $('#cts-modal .product-sizes-title-size').show();
      $wrapper.removeClass();
      $wrapper.addClass('product-sizes-wrapper product-sizes').addClass($('.oa-product-logos--item.active').attr('data-selection-logo')).addClass($('.oa-product-sizes--item.active').attr('data-selection-size'));
      if($selectedSize!=undefined && !$fashionVariant.hasClass('disabled')){
        $fashionVariant.addClass('active');
        if($('#cts-modal .oa-product-sizes--item').hasClass('active')&&$('#cts-modal .oa-product-sizes--item-size').hasClass('active')){

          $addToCartBtn.attr("disabled", false);
          $('#oa-fashion #cts-modal .fashion-info-flex #in-den-warenkorb').removeClass('select');
          $('#cts-modal .product-sizes').not('#product-stl .product-sizes').removeClass('red');
          $('#cts-modal .choose-size-alert').hide(100);
        }
      } else {
        if($('#cts-modal .oa-product-sizes--item-size.active').length == 0){
         $input.val('');
        }
      }
      if($('#cts-modal .oa-product-sizes--item-size.active').length == 0){
        $input.val('');
      }
    });

    //PP Fashion Logo APPLICATION pop up
    /*$('.product-logos .oa-product-logos--item').hover(function() {
      $('.product-logos-popup [data-selected-logo="'+$(this).data('selection-logo')+'"]').toggle();
        $('.product-logos-popup').toggle('slow');
    });*/
    

    if(isMobile() || true){ 
      $('.product-logos-title span').click(function(){
        $('.product-logos-popup [data-selected-logo="heat"]').toggle();  
        $('.product-logos-popup [data-selected-logo="engineered"]').toggle();  
        $('.product-logos-popup').toggle();
      });

    $('.product-logos-popup--close').click(function(){
        $('.product-logos-popup').hide();
        $('.product-logos-popup [data-selected-logo="heat"]').hide();  
        $('.product-logos-popup [data-selected-logo="engineered"]').hide();  
    });
    }else{
    $('.product-logos .oa-product-logos--item').hover(function(){
        $('.product-logos-popup [data-selected-logo="'+$(this).data('selection-logo')+'"]').show();
        $('.product-logos-popup').show();
      },function() {
        $('.product-logos-popup').hide();
        $('.product-logos-popup [data-selected-logo="'+$(this).data('selection-logo')+'"]').hide();        
    });
    }
     
    
    //PP Fashion Logo APPLICATION switch
    $('.product-logos .oa-product-logos--item').click(function(){
      //$('.product-logos-popup').hide();
      var $selectedLogo = $('.oa-product-sizes--item-size.active').attr('data-size-name');
      var $sizeSelection = $(this).attr('data-selection-size');
      var $logoSelection = $(this).attr('data-selection-logo');
      var $fashionVariant= $('.oa-product-sizes--item-size-'+$sizeSelection+'[data-size-name="'+$selectedLogo+'"]');
      var $wrapper = $('.product-sizes-wrapper');
      
      $('.product-logos .oa-product-logos--item').removeClass('active');
      $sizeBtnsSelected.removeClass('active');
      $(this).addClass('active');
      $('.product-length-wrapper').not('#product-stl .product-length-wrapper').removeClass('red');
      $('.oa-product-sizes--item-size').hide();
      $('.oa-product-sizes--item-size-'+$logoSelection).show();
      $('.product-sizes-title-size').show();


      $wrapper.removeClass();
      $wrapper.addClass('product-sizes-wrapper product-sizes').addClass($('.oa-product-logos--item.active').attr('data-selection-logo')).addClass($('.oa-product-sizes--item.active').attr('data-selection-size'));

      
      
      if($selectedLogo!=undefined && !$fashionVariant.hasClass('disabled')){
        $fashionVariant.addClass('active');
        if($('.oa-product-logos--item').hasClass('active')&&$('.oa-product-sizes--item-size').hasClass('active')){

          $addToCartBtn.attr("disabled", false);
          $('#oa-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');
          $('.product-logos').removeClass('red');
          $('.choose-size-alert').hide(100);
        }
      } else {
        if($('.oa-product-sizes--item-size.active').length == 0){
          $input.val('');
        }
      }
      if($('.oa-product-sizes--item-size.active').length == 0){
        $input.val('');
      }
      
    });


    $('.oa-product-addtocart-btn:not(.oa-product-addtocart-btn-cts)').on('click', function(event){
      if ($('.oa-product-addtocart-btn').hasClass('early-access-cta')) {
        //
      } else {
        if ($input.val() == ''){
          event.preventDefault();
          if($('.oa-product-sizes--item').hasClass('active')){
            $('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper').addClass('red');
          }else if($('.oa-product-sizes--item-size').hasClass('active')){
            $('.product-length-wrapper').not('#product-stl .product-length-wrapper').addClass('red');
          }else{
            $('.product-sizes').not('#product-stl .product-sizes').addClass('red');
          }
          $('.choose-size-alert').show(100);
        }
      }
    });

    $sizeBtnsSelected.each(function(i) {
      var $this = $(this);
      $this.on('click', function(e) {
        var $this = $(this);
        var variant_id = $(this).data('size');

        if ($this.hasClass('disabled') == false) {
          //Classes
          $sizeBtnsSelected.removeClass('active');
          $this.addClass('active');

          $('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper').removeClass('red');
          if($('.oa-product-sizes--item-size').hasClass('active')){
            $('.choose-size-alert').hide(100);
          }
          if (variant_id) {
            $addToCartBtn.attr("disabled", false);
            $input.val(variant_id);
            // $('#oa-fashion .fashion-info-flex #in-den-warenkorb').css('background','#000');
            $('#oa-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');

            document.dispatchEvent(new CustomEvent('oa:variantchange', { detail: { sku: $this.data('sku'), id: $this.data('size'), name: $this.data('title'), sizeName: $this.data('size-name') } }));
          } else {
            //$addToCartBtn.attr("disabled", true);
          }

        }
      });
    });


    $('.is-sticky #in-den-warenkorb.select').on('click', function(){
      if (!$(this).hasClass('select')) {
        return;
      }
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".fashion-info-flex").offset().top-100
      }, 500);
    });
  }

  setupFashionView();

}, { passive: true });

document.addEventListener('DOMContentLoaded', function () {
  var $$ = window.Swiper.$;

  function setupTabs() {
    var desktopTabs = Array.prototype.slice.call(document.querySelectorAll('.desktop-tab'));
    desktopTabs.forEach(function(desktopTab) {
      var tabHeadlines = Array.prototype.slice.call(desktopTab.querySelectorAll('.desktop-tab-headline[data-tab]'));
      tabHeadlines.forEach(function(tabHeadline) {
        tabHeadline.addEventListener('click', function (event) {
          var tabId = tabHeadline.getAttribute('data-tab');
          var tabContent = tabHeadline.nextElementSibling.classList.contains('desktop-tab-content') && tabHeadline.nextElementSibling.getAttribute('data-tab-content') === tabId ? tabHeadline.nextElementSibling : desktopTab.querySelector('.desktop-tab-content[data-tab-content="' + tabId + '"]');
          if (!tabContent) {
            return;
          }
          event.preventDefault();
          $(tabContent).slideToggle(225);
          tabHeadline.classList.toggle('active');
        });
      });
    });

    document.addEventListener('oa:variantchange', function (event) {
      if (!event.detail) { return; }
      desktopTabs.forEach(function (desktopTab) {
        if(window.location.href.includes('lagoon-marl') || window.location.href.includes('guava-marl') || window.location.href.includes('coral-marl')) {
          return;
        }
        if(event.detail.sizeName == 'XL' && window.location.href.includes('classic-seamless-sports-bra')) {
          return;
        }
        if((event.detail.sizeName == 'XL' || event.detail.sizeName == 'L' || event.detail.sizeName == 'XS') && window.location.href.includes('classic-lounge')) {
          return;
        }

        if((event.detail.sizeName == 'M') && (window.location.href.includes('classic-lounge-crew') || window.location.href.includes('classic-lounge-sweatshorts'))) {
          return;
        }
        if(window.location.href.includes('classic-seamless-shorts') || window.location.href.includes('classic-seamless-tank-top')) {
          return;
        }
        //desktopTab.setAttribute('data-athlete-size-name', event.detail.sizeName);
      });
    }, false);
  }

  function setupPreviews() {
    var elTarget = document.querySelector('.oa-single-product_product-image-container picture');
    if (!elTarget) {
      return;
    }
    var elPreviews = Array.prototype.slice.call(document.querySelectorAll('.oa-single-product_product-image-previews-container img'));
    if (elPreviews.length < 1) {
      return;
    }

    elPreviews.forEach(function (elPreview) {
      elPreview.addEventListener('click', function () {
        window.oaPicture.replaceSrc(elTarget, elPreview.getAttribute('src') || elPreview.getAttribute('data-src'));
      }, { passive: true });
    });
  }

  function setupMagnify() {
    var elImgZoom = $$('#img-zoom');
    if (elImgZoom.length !== 1) {
      return;
    }

    function onMouseLeave(elImgZoom, event) {
      elImgZoom.transition(0).transform('translate3d(0,0,0) scale(1)').css({ opacity: 0});
    }
    function onMouseMove(elMagnify, elImgZoom, event) {
      var x = Math.min(Math.max((event.offsetX / elMagnify.outerWidth()) * 100, 0), 100);
      var y = Math.min(Math.max((event.offsetY / elMagnify.outerHeight()) * 100, 0), 100);
      elImgZoom.transition(0).css('transformOrigin', x + '% ' + y + '%');
    }
    function onMouseEnter(elMagnify, elImgZoom, event) {
      var src = elMagnify.attr('data-magnify-src') || '';
      elImgZoom.transition(0).css({ backgroundImage: 'url(' + src + ')' }).transform('translate3d(0,0,0) scale(2)').css({ opacity: 1 });
    }

    $$('img[data-magnify-src]').each(function (elIndex, elMagnify) {
      elMagnify = $$(elMagnify);
      elMagnify.on('mouseenter', onMouseEnter.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mousemove', onMouseMove.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mouseleave', onMouseLeave.bind(undefined, elImgZoom), false);
    });
  }

  setupTabs();
  setupPreviews();
  setupMagnify();
}, { passive: true });

window.initCabSlider = function () {
  initProductSlider('#cab_slider');
  initProductSlider('#cab_slider_new');
}
